import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned, Row } from '@/components/layout/layout'
import './stock-search.scss'
import StockSearchTable from './stock-search-table/stock-search-table'
import { DatePicker } from 'antd'
import { stockSearchModel } from './model'
import SearchInput from '@/components/search-input/search-input'
import StockSearchFilter from './stock-search-filter/stock-search-filter'
import { stockSearchFilterStore } from './stock-search-filter/filter-store'
import { observer } from 'mobx-react'
import { layerManage, showLayer } from '@/utils/layer'

const StockSearch = observer(() => {
    const getCls = (e?: string, m?: string) => getBEMCls('stock-search', e, m)

    const [date, setDate] = useState<string[]>([])

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <SearchInput
                        isExpaned={false}
                        placeholder="请输入关键词搜索"
                        onDelete={() => {
                            stockSearchModel.setKeyWord('')
                        }}
                        onSearch={val => {
                            stockSearchModel.setKeyWord(val)
                        }}
                    />
                    <div
                        className="time-picker"
                        style={{
                            marginLeft: '16px',
                        }}
                    >
                        <DatePicker.RangePicker
                            dateRender={current => (
                                <div
                                    className="ant-picker-cell-inner"
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                >
                                    {current.date()}
                                </div>
                            )}
                            onChange={(monent, dateString) => {
                                setDate(dateString[0] ? dateString : [])
                            }}
                            suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                        />
                    </div>
                    <div
                        className={getCls('filter')}
                        data-cursor-pointer
                        onClick={() => {
                            showLayer(<StockSearchFilter onCancel={() => layerManage.pop()} />)
                        }}
                        style={{
                            color: !stockSearchFilterStore.filterTxt ? '#333' : '#14cc9b',
                        }}
                    >
                        <i className="iconfont icon6shaixuan-20" data-font-size-20 />
                        <span data-margin-left-8>筛选</span>
                    </div>
                </div>

                {!!stockSearchFilterStore.filterTxt && (
                    <Row className={getCls('searchBox')}>
                        <div>
                            筛选：
                            <span className="them-color" data-font-weight-600 data-padding-h-8>
                                {stockSearchFilterStore.filterTxt}
                            </span>
                        </div>
                        <div
                            className={getCls('delete')}
                            onClick={() => {
                                stockSearchFilterStore.reset()
                            }}
                        >
                            <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                        </div>
                    </Row>
                )}

                <Expaned data-row className={getCls('content')}>
                    <StockSearchTable date={date} />
                </Expaned>
            </Expaned>
        </>
    )
})

export default StockSearch
